/* eslint-disable fp/no-mutation */
export type FileData = {
  name: string
  type: string
  extension: string
  file: Blob | null
}

export type ContentType = 'application/pdf' | 'image/jpeg' | 'image/png'

export const contentTypes: ContentType[] = ['application/pdf', 'image/jpeg', 'image/png']

export function downloadFile(data: Blob | string, fileName: string) {
  let url = window.URL.createObjectURL(new Blob([data]))
  let link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
}

export function downloadFileFromURL(url: string, fileName: string) {
  let link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
}
